<template>
    <modal
        v-if="show"
        class="previewTollFreeBusinessProfileModal"
        :type="'is-small'"
        :title="'Toll-Free'"
        :hideFoot="true"
        @closed="closed"
    >
        <div class="complianceModal__content">
            <div class="profileViewDetails">
                <div class="profileViewDetails__box">
                    <div class="profileViewDetails__title-block">
                        <p v-if="!isPhoneView" class="profileViewDetails__title">
                            {{ item.title || '' }}
                        </p>
                        <div v-else class="toll-free__details__modal">
                            <p class="profileViewDetails__title">
                                {{ formattedNumber || '' }}
                            </p>
                            <div v-if="hasPhoneVerificationErrors">
                                <form-message
                                    v-for="(verificationError, idx) in phoneVerificationErrors"
                                    :key="`${idx}_${verificationError.rejection_reason}`"
                                    type="is-danger"
                                    icon="info-circle"
                                    :message="verificationError.rejection_reason"
                                />
                            </div>
                            <div>
                                <button
                                    v-if="isFaildStatus"
                                    class="button is-danger is-fullwidth"
                                    @click="handleShowUpdate"
                                >
                                    Update
                                </button>
                            </div>
                            <span
                                class="toll-free__details__title"
                                :style="{ color: getStatColor(numberStatus) }"
                            >
                                <fa-icon
                                    :icon="getStatIcon(numberStatus)"
                                    :style="getStatColor(numberStatus)"
                                />
                                {{ getStatTitle(numberStatus) }}
                            </span>
                            <span v-if="hasEstimation(numberItem)" class="estimate-divider">|</span>
                            <span v-if="hasEstimation(numberItem)" class="estimate-time"
                            >Estimated response in 28 days</span
                            >
                            <fa-icon
                                v-if="hasEstimation(numberItem)"
                                v-tooltip.top="{
                                    content: `Please allow 14-28 days for carriers to review your Toll-Free number. <a href='https://help.salesmessage.com/en/articles/6150476-toll-free-message-verification-usa-canada#h_d4f72d3c77' target='_blank'>Learn more</a>
                                            <br />
                                            <br />
                                            Submitted on ${estimation(numberItem)}.`,
                                    autoHide: false,
                                }"
                                icon="exclamation-circle"
                                class="estimate-icon"
                            />
                        </div>
                    </div>
                    <form-message
                        v-if="item.statusIncomplete && !isPhoneView"
                        type="is-danger"
                        icon="info-circle"
                        message="The Toll-Free verification process wasn’t complete"
                    />
                    <button
                        v-if="item.statusIncomplete && !isPhoneView"
                        class="button is-danger is-fullwidth"
                        @click="handleShowDelete(item)"
                    >
                        Delete
                    </button>
                    <div class="profileViewDetails__block">
                        <p v-if="!isPhoneView" class="column_title">Profile info</p>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Name</span>
                            <span class="column_value">{{
                                (numberProfile && numberProfile.title) || item.title || '-'
                            }}</span>
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Expected monthly messages</span>
                            <span class="column_value"
                            >1-{{
                                (numberProfile && numberProfile.monthly_volume) ||
                                    item.monthly_volume ||
                                    number ||
                                    '-'
                            }}</span
                            >
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Use case</span>
                            <span v-if="isPhoneView" class="column_value">{{
                                item.use_case ? item.use_case.title : '-'
                            }}</span>
                            <span v-else class="column_value">{{
                                numberProfile && numberProfile.use_case
                                    ? numberProfile.use_case.title
                                    : '-'
                            }}</span>
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Description</span>
                            <span class="column_value">{{
                                (numberProfile && numberProfile.use_case_description) ||
                                    item.use_case_description ||
                                    '-'
                            }}</span>
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Package</span>
                            <span v-if="item.opt_in_methods.length" class="column_value">
                                <ul
                                    v-for="method in item.opt_in_methods"
                                    v-bind:key="method.id"
                                    class="column_value__column"
                                >
                                    <li>- {{ method.title }}</li>
                                </ul>
                            </span>
                            <span v-else class="column_value">-</span>
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Sample message 1</span>
                            <span class="column_value">
                                {{
                                    (numberProfile && numberProfile.sample_message_1) ||
                                    item.sample_message_1 ||
                                        '-'
                                }}
                            </span>
                        </div>
                        <div class="profileViewDetails__info">
                            <span class="column_label">Sample message 2</span>
                            <span class="column_value">{{
                                (numberProfile && numberProfile.sample_message_2) ||
                                    item.sample_message_2 ||
                                    '-'
                            }}</span>
                        </div>
                    </div>
                    <div v-if="!isPhoneView" class="profileViewDetails__block">
                        <p class="column_title">Numbers</p>
                        <div
                            v-if="item.numbers.length > 0"
                            class="profileViewDetails__info numbers"
                        >
                            <div
                                v-for="number in item.numbers"
                                v-bind:key="number.id"
                                class="numbers__column"
                            >
                                <span class="number_value">{{
                                    number.formatted_number || '-'
                                }}</span>
                                <span class="status" :style="getIconStyle(number.verified_status)">
                                    <fa-icon
                                        :icon="getIcon(number.verified_status)"
                                        :style="getIconStyle(number.verified_status)"
                                    />
                                    {{ number.verified_status || '-' }}
                                </span>
                            </div>
                        </div>
                        <div v-else class="profileViewDetails__info">
                            <span class="column_label">Empty</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import moment from 'moment';

export default {
    emits: ['closed', 'showUpdate', 'showDelete'],

    computed: {
        show() {
            return this.showTollFreeDetailsModal;
        },

        numberItem() {
            return this.showTollFreeDetailsModalNumberItem;
        },

        modalType() {
            return this.showTollFreeDetailsModalType;
        },

        item() {
            return this.showTollFreeDetailsItem;
        },

        numberProfile() {
            return this.numberItem?.individual_toll_free_profile || null;
        },

        hasPhoneVerificationErrors() {
            if (!(this.numberStatus === 'Denied' || this.numberStatus === 'Blocked')) {
                return false;
            }

            if (!Array.isArray(this.numberItem?.toll_free_verification_errors)) {
                return false;
            }

            return this.numberItem?.toll_free_verification_errors?.length > 0;
        },

        isFaildStatus() {
            return this.numberStatus === 'Denied' || this.numberStatus === 'Blocked';
        },

        phoneVerificationErrors() {
            if (!Array.isArray(this.numberItem?.toll_free_verification_errors)) {
                return [];
            }

            return this.numberItem.toll_free_verification_errors;
        },

        isPhoneView() {
            return this.modalType === 'numberView';
        },

        formattedNumber() {
            return this.numberItem?.formattedNumber;
        },

        numberStatus() {
            return this.numberItem?.verified_status;
        },

        ...mapState(stores.ComplianceProfile, [
            'tollFreeFormFieldsMonthlyValues',
            'tollFreeFormFieldsUseCases',
            'tollFreeFormFieldsOptInMethods',
        ]),
        ...mapState(stores.TollFreeStore, [
            'showTollFreeDetailsModal',
            'showTollFreeDetailsModalNumberItem',
            'showTollFreeDetailsModalType',
            'showTollFreeDetailsModalUseShowUpdateModal',
            'showTollFreeDetailsItem',
        ]),
    },

    methods: {
        getIcon(status) {
            if (status === 'Under Review') {
                return 'clock';
            }
            if (status === 'Verified') {
                return 'check-circle';
            }

            return 'times-circle';
        },

        getIconStyle(status) {
            if (status === 'Under Review') {
                return { color: '#7A7A7A' };
            }
            if (status === 'Verified') {
                return { color: '#13B763' };
            }

            return { color: '#DA5350' };
        },

        closed() {
            this.$store.dispatch('handleShowTollFreeDetailsModal', {
                status: false,
                numberItem: null,
                type: null,
                useShowUpdateModal: false,
                item: null,
            });
            this.$emit('closed');
        },

        handleShowDelete(item) {
            this.$store.dispatch('handleShowTollFreeDeleteModal', {
                status: true,
                item: item,
            });
            this.$emit('showDeleteProfile', true, item);
            this.closed();
        },

        handleShowUpdate() {
            if (this.showTollFreeDetailsModalUseShowUpdateModal) {
                this.$store.dispatch('setTollFreeDataForRecoveredVerification', this.item);
                this.$store.dispatch('setTollFreeNumber', null);
                this.$store.dispatch('handleShowTollFreeVerificationModal', {
                    status: true,
                    type: 'numberView',
                    disabledNumbersStep: true,
                    phoneUpdateData: this.numberItem,
                });
            }

            this.$emit('showUpdateModal', true, this.numberItem, this.item);
            this.closed();
        },

        getStatTitle(status) {
            switch (status) {
                case 'Unverified':
                    return 'Pending Review';
                case 'Under Review':
                    return 'In Carrier Review';
                case 'Denied':
                    return 'Rejected';
                case 'Blocked':
                    return 'Blocked';
                case 'Verified':
                    return 'Approved';
                default:
                    return '';
            }
        },

        getStatColor(status) {
            switch (status) {
                case 'Unverified':
                    return '#7A7A7A';
                case 'Under Review':
                    return '#7A7A7A';
                case 'Denied':
                    return '#DA5350';
                case 'Blocked':
                    return '#DA5350';
                case 'Verified':
                    return '#13B763';
                default:
                    return '';
            }
        },

        getStatIcon(status) {
            switch (status) {
                case 'Unverified':
                    return 'clock';
                case 'Under Review':
                    return 'clock';
                case 'Denied':
                    return 'times-circle';
                case 'Blocked':
                    return 'times-circle';
                case 'Verified':
                    return 'check-circle';
                default:
                    return '';
            }
        },

        hasEstimation(number) {
            return (
                number.verified_status === 'Under Review' &&
                (this.item?.updated_at || number?.individual_toll_free_profile?.updated_at)
            );
        },

        estimation(number) {
            if (number?.individual_toll_free_profile?.updated_at) {
                return moment(number.individual_toll_free_profile.updated_at).format(
                    'MMM D, YYYY [at] h:mm a z'
                );
            }

            if (this.item?.updated_at) {
                return moment(this.item?.updated_at).format('MMM D, YYYY [at] h:mm a z');
            }

            return null;
        },
    },
};
</script>

<style lang="scss" scoped>
.previewTollFreeBusinessProfileModal {
    .complianceModal__content {
        padding: 0;
    }

    .toll-free__details__modal {
        margin-bottom: 20px;
        width: 100%;

        .toll-free__details__title {
            .icon {
                bottom: -3px;
                position: relative;
            }
        }

        .estimate-divider {
            padding: 0 7px;
            color: #7a7a7a;
        }

        .estimate-time {
            color: #a1770b;
        }

        .estimate-icon {
            bottom: -3px;
            position: relative;
            color: #7a7a7a;
        }
    }

    .button.is-danger {
        margin-bottom: 20px;
    }

    .profileViewDetails__title-block {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .profileViewDetails__title {
            font-weight: 600;
            font-size: 21px;
            line-height: 150%;
            color: #363636;
            margin-bottom: 10px;
        }

        .profileViewDetails__icon {
            color: #7a7a7a;
        }
    }

    .profileViewDetails__block {
        width: 100%;
        margin-bottom: 20px;

        .column_title {
            font-weight: 600;
            font-size: 14px;
            line-height: 150%;
            color: #363636;
            margin-bottom: 20px;
        }

        .profileViewDetails__info {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 10px;

            .column_label {
                font-weight: 400;
                font-size: 14px;
                line-height: 170%;
                white-space: nowrap;
                color: #7f7f7f;
                padding-right: 10px;
                text-align: left;
            }

            .column_value {
                font-weight: 400;
                font-size: 14px;
                line-height: 170%;
                color: #4a4a4a;
                text-align: end;
                max-width: 200px;

                &__column {
                    width: max-content;
                    text-align: left;
                }
            }

            &.numbers {
                flex-direction: column;
                justify-content: space-between;

                .numbers__column {
                    width: 100%;
                    justify-content: space-between;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                .number_value {
                    color: #4b4b4b;
                    font-weight: 400;
                    font-size: 14px;
                }

                .status {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }
            }
        }
    }
}
</style>
